// src-mlr/app.route.js

routing.$inject = ['$urlRouterProvider', '$locationProvider', '$stateProvider'];

export default function routing($urlRouterProvider, $locationProvider, $stateProvider)
 {
  $urlRouterProvider.deferIntercept();
  $urlRouterProvider.otherwise("/error");
  $locationProvider.html5Mode( {
    enabled: true,
    requireBase: false
  });

  var stateUrls = {
    // keys should match view component names
    clearcache : '/clear-cache',
    error : '/error',
    home: '/'
  }

  Object.keys(stateUrls).forEach(stateKey => {
    $stateProvider.state({
      name: stateKey,
      component: stateKey,
      url: stateUrls[stateKey]
    });
  });
}
